
{
  "familyId": "GET-KOMMA-KEER",
  "questions": [
    {
      "id": "GET-KOMMA-KEER-001",
      "familyId": "GET-KOMMA-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Wat is 0,3 × 4?",
      "options": ["1,2", "0,12", "12", "0,7"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetal vermenigvuldigen — komma terugplaatsen",
            "content": "Reken eerst zonder komma. Tel daarna het totaal aantal cijfers achter de komma in de opgave. Zet de komma op die plek terug in het antwoord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_keer_heel_getal",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Reken eerst zonder komma: 3 × 4 = 12. Tel daarna de decimalen: 0,3 heeft 1 cijfer achter de komma → het antwoord ook 1 cijfer achter de komma. 12 → 1,2. Controleer: 1,2 ÷ 4 = 0,3 ✓.",
        "solutionSteps": [
          "Reken zonder komma: 3 × 4 = 12",
          "Tel de decimalen in de opgave: 0,3 heeft 1 decimaal",
          "Zet de komma terug: 12 → 1,2 (1 decimaal)",
          "Check: 1,2 ÷ 4 = 0,3 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 0,3 × 4 = 1,2. Eén cijfer achter de komma in de opgave → één cijfer achter de komma in het antwoord.",
          "1": "Je dacht waarschijnlijk dat de komma twee plaatsen naar links gaat. Maar 0,3 heeft maar 1 decimaal, dus het antwoord heeft ook 1 decimaal: 1,2, niet 0,12. Onthoud: tel het aantal decimalen in de opgave.",
          "2": "Je dacht waarschijnlijk dat de komma er niet toe doet. Maar 3 × 4 = 12 en 0,3 × 4 = 1,2 — de komma schuift het antwoord één plek naar links. Onthoud: vergeet de komma niet terug te plaatsen.",
          "3": "Je dacht waarschijnlijk dat je moest optellen. Maar de vraag is vermenigvuldigen: 0,3 × 4 = 1,2, niet 0,3 + 0,4 = 0,7. Onthoud: het × teken betekent vermenigvuldigen."
        }
      }
    },
    {
      "id": "GET-KOMMA-KEER-002",
      "familyId": "GET-KOMMA-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Wat is 2,5 × 3?",
      "options": ["7,5", "7,15", "75", "5,5"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetal splitsen bij vermenigvuldigen",
            "content": "Splits het kommagetal in een heel deel en een decimaal deel. Vermenigvuldig elk deel apart en tel op. Voorbeeld: 2,5 × 3 = (2 × 3) + (0,5 × 3) = 6 + 1,5 = 7,5.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_keer_tienden",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Splits het kommagetal: 2 × 3 = 6 en 0,5 × 3 = 1,5. Tel op: 6 + 1,5 = 7,5. Controleer: 7,5 ÷ 3 = 2,5 ✓.",
        "solutionSteps": [
          "Splits het kommagetal: 2,5 = 2 + 0,5",
          "Vermenigvuldig elk deel: 2 × 3 = 6 en 0,5 × 3 = 1,5",
          "Tel op: 6 + 1,5 = 7,5",
          "Check: 7,5 ÷ 3 = 2,5 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2,5 × 3 = 7,5. Je kunt splitsen: (2 × 3) + (0,5 × 3) = 6 + 1,5 = 7,5.",
          "1": "Je dacht waarschijnlijk dat je de eenheden en tienden apart vermenigvuldigt en naast elkaar schrijft. Maar 2 × 3 = 6 en 5 × 3 = 15 → 7,15 klopt niet. De 5 is 0,5, dus 0,5 × 3 = 1,5. Onthoud: de tienden zijn tienden, niet eenheden.",
          "2": "Je dacht waarschijnlijk dat de komma er niet toe doet. Maar 25 × 3 = 75 en 2,5 × 3 = 7,5 — de komma schuift het antwoord één plek naar links. Onthoud: vergeet de komma niet terug te plaatsen.",
          "3": "Je dacht waarschijnlijk dat je moest optellen. Maar de vraag is vermenigvuldigen: 2,5 × 3 = 7,5, niet 2,5 + 3 = 5,5. Onthoud: het × teken betekent vermenigvuldigen."
        }
      }
    },
    {
      "id": "GET-KOMMA-KEER-003",
      "familyId": "GET-KOMMA-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Wat is 0,4 × 0,3?",
      "options": ["0,12", "1,2", "0,7", "0,012"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee kommagetallen vermenigvuldigen",
            "content": "Tel het totaal aantal cijfers achter de komma in beide getallen op. Dat is het aantal decimalen in het antwoord. Voorbeeld: 0,4 × 0,3 → 1 + 1 = 2 decimalen → antwoord heeft 2 decimalen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_keer_komma",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Reken eerst zonder komma: 4 × 3 = 12. Tel daarna de decimalen: 0,4 heeft 1 decimaal + 0,3 heeft 1 decimaal = 2 decimalen totaal. 12 → 0,12. Controleer: 0,12 ÷ 0,3 = 0,4 ✓.",
        "solutionSteps": [
          "Reken zonder komma: 4 × 3 = 12",
          "Tel de decimalen: 0,4 heeft 1 + 0,3 heeft 1 = 2 decimalen totaal",
          "Zet de komma terug: 12 → 0,12 (2 decimalen)",
          "Check: 0,12 ÷ 0,3 = 0,4 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 0,4 × 0,3 = 0,12. Twee decimalen in de opgave → twee decimalen in het antwoord.",
          "1": "Je dacht waarschijnlijk dat je maar één decimaal hoeft te tellen. Maar 0,4 heeft 1 decimaal én 0,3 heeft 1 decimaal: samen 2 decimalen. Antwoord: 0,12, niet 1,2. Onthoud: tel alle decimalen in de opgave bij elkaar op.",
          "2": "Je dacht waarschijnlijk dat je moest optellen. Maar de vraag is vermenigvuldigen: 0,4 × 0,3 = 0,12, niet 0,4 + 0,3 = 0,7. Onthoud: het × teken betekent vermenigvuldigen.",
          "3": "Je dacht waarschijnlijk dat het antwoord 3 decimalen heeft. Maar 1 + 1 = 2 decimalen, niet 3. Antwoord: 0,12, niet 0,012. Onthoud: tel het totaal aantal decimalen in de opgave."
        }
      }
    },
    {
      "id": "GET-KOMMA-KEER-004",
      "familyId": "GET-KOMMA-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Een plank is 1,8 meter lang. Je hebt 5 planken nodig. Hoeveel meter hout heb je in totaal nodig?",
      "options": ["9 meter", "0,9 meter", "6,8 meter", "90 meter"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetal vermenigvuldigen met een heel getal",
            "content": "Reken eerst zonder komma: 18 × 5 = 90. Tel daarna de decimalen in de opgave: 1,8 heeft 1 decimaal. Zet de komma terug: 90 → 9,0 = 9.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_keer_context",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Reken eerst zonder komma: 18 × 5 = 90. Tel de decimalen: 1,8 heeft één cijfer achter de komma, dus het antwoord ook: 90 → 9,0 = 9 meter. Je hebt 9 meter hout nodig.",
        "solutionSteps": [
          "Reken zonder komma: 18 × 5 = 90",
          "Tel de decimalen: 1,8 heeft 1 decimaal",
          "Zet de komma terug: 90 → 9,0 = 9 meter",
          "Check: 9 ÷ 5 = 1,8 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1,8 × 5 = 9 meter. Eén decimaal in de opgave → één decimaal in het antwoord: 9,0 = 9.",
          "1": "Je dacht waarschijnlijk dat de komma twee plaatsen naar links gaat. Maar 1,8 heeft maar 1 decimaal: 90 → 9,0 = 9 meter, niet 0,9 meter. Onthoud: tel het aantal decimalen in de opgave.",
          "2": "Je dacht waarschijnlijk dat je 1,8 en 5 bij elkaar optelt. Maar je hebt 5 planken van elk 1,8 m nodig: dat is vermenigvuldigen. 1,8 × 5 = 9, niet 1,8 + 5 = 6,8.",
          "3": "Je dacht waarschijnlijk dat de komma er niet toe doet. Maar 18 × 5 = 90 en 1,8 × 5 = 9 — de komma schuift het antwoord één plek naar links. Onthoud: tel het aantal decimalen en zet de komma terug."
        }
      }
    },
    {
      "id": "GET-KOMMA-KEER-005",
      "familyId": "GET-KOMMA-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Wat is 1,25 × 8?",
      "options": ["10", "1,0", "100", "9,25"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetal splitsen bij vermenigvuldigen",
            "content": "Splits 1,25 in een heel deel en een decimaal deel: 1 × 8 = 8 en 0,25 × 8 = 2. Tel op: 8 + 2 = 10. Of: 125 × 8 = 1000, twee decimalen → 10,00 = 10.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_keer_honderdsten",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Splits het op: 1 × 8 = 8 en 0,25 × 8 = 2. Tel op: 8 + 2 = 10. Of: 125 × 8 = 1000, twee decimalen → 10,00 = 10. Handig om te onthouden: 1,25 = 1¼, en 1¼ × 8 = 10.",
        "solutionSteps": [
          "Splits: 1,25 = 1 + 0,25",
          "Vermenigvuldig elk deel: 1 × 8 = 8 en 0,25 × 8 = 2",
          "Tel op: 8 + 2 = 10",
          "Check: 10 ÷ 8 = 1,25 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1,25 × 8 = 10. Handig om te onthouden: 1,25 = 1¼, en vier kwarten × 8 = 10.",
          "1": "Je dacht waarschijnlijk dat het antwoord 1,0 is. Maar 1,25 × 8 = 10, niet 1,0. Je hebt misschien 125 × 8 = 1000 uitgerekend en de komma drie plaatsen verschoven in plaats van twee. Onthoud: 1,25 heeft 2 decimalen → 1000 → 10,00 = 10.",
          "2": "Je dacht waarschijnlijk dat de komma er niet toe doet. Maar 125 × 8 = 1000 en 1,25 × 8 = 10 — twee decimalen in de opgave → twee decimalen terug: 1000 → 10,00 = 10.",
          "3": "Je dacht waarschijnlijk dat je 1,25 en 8 bij elkaar optelt. Maar de vraag is vermenigvuldigen: 1,25 × 8 = 10, niet 1,25 + 8 = 9,25."
        }
      }
    }
  ]
}
